import { BoxNetworkModeItem } from '@/box/interface'
import { getFormatMessage } from '@/utils/utils'
import { Button, Col, Form, Radio, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { isGprs, isWifi } from '../../shared/Shared'
import { Title } from '../../shared/Title'

export interface BoxDetailNetModeProps {
  title?: boolean
  disabled?: boolean
  subType?: number
  editItem?: BoxNetworkModeItem
  onSave?: (item: BoxNetworkModeItem) => void
}

export const BoxDetailNetMode: React.FC<BoxDetailNetModeProps> = (
  props: BoxDetailNetModeProps
) => {
  const { title, subType, disabled, editItem, onSave } = props
  const formatMessage = getFormatMessage()
  const [networkMode, setNetworkMode] = useState<number>(1)
  const [loading, setLoading] = useState<boolean>(false)

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 5 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 }
    }
  }

  const handleNetworkSave = async () => {
    if (!onSave) return
    let mode = networkMode
    if (networkMode === 1) {
      mode = 1
    } else if (networkMode === 2) {
      mode = 4
    } else {
      mode = subType || 1
      if (mode > 4) {
        mode = 5
      }
    }
    try {
      setLoading(true)
      await onSave({ networkMode: mode })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (editItem) {
      if (editItem.networkMode === 1) {
        setNetworkMode(1)
      } else if (editItem.networkMode === 4) {
        setNetworkMode(2)
      } else {
        setNetworkMode(3)
      }
    }
  }, [editItem])

  return (
    <Form {...formItemLayout} labelAlign='right'>
      {title && (
        <Title
          level={4}
          extra={
            <Button
              type='primary'
              disabled={disabled}
              loading={loading}
              onClick={handleNetworkSave}
            >
              {formatMessage({ id: 'app.box.detail.edit.save' })}
            </Button>
          }
        >
          {formatMessage({ id: 'app.box.detail.edit.networkMode' })}
        </Title>
      )}

      <Row>
        <Col span={24}>
          <Form.Item>
            <Radio.Group
              value={networkMode}
              disabled={disabled}
              onChange={(e) => setNetworkMode(e.target.value)}
            >
              <Radio value={1}>
                {formatMessage({ id: 'app.box.networkMode.1' })}
              </Radio>
              <Radio value={2} disabled={!isWifi(subType)}>
                {formatMessage({ id: 'app.box.networkMode.2' })}
              </Radio>
              <Radio value={3} disabled={!isGprs(subType)}>
                {formatMessage({ id: 'app.box.networkMode.3' })}
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}
